import forkGreenLogo from '@/assets/fork-green.svg';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';

interface Props {
  seekCandidateNumber: number | null | undefined;
  size?: number;
}

/** Shows the green ForkSeek fork logo next to a candidate's name when they have a ForkSeek account */
export function ForkSeekAccountBadge({ seekCandidateNumber, size = 14 }: Props) {
  if (!seekCandidateNumber) return null;

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <img src={forkGreenLogo} alt="ForkSeek account" className="inline-block flex-shrink-0" style={{ width: size, height: size }} />
      </TooltipTrigger>
      <TooltipContent side="top" className="text-xs">
        ForkSeek Account
      </TooltipContent>
    </Tooltip>
  );
}
